import { render, staticRenderFns } from "./JournalAuditDialog.vue?vue&type=template&id=b5049020&scoped=true"
import script from "./JournalAuditDialog.vue?vue&type=script&lang=js"
export * from "./JournalAuditDialog.vue?vue&type=script&lang=js"
import style0 from "./JournalAuditDialog.vue?vue&type=style&index=0&id=b5049020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5049020",
  null
  
)

export default component.exports